// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__kRCFs","marker":"styles_marker__9QTmx"};